import { StoreClass } from "../stores/Store";

class ClarityClass {

    store:StoreClass
    push(eventName){
        if(window.clarity && typeof window.clarity === 'function'){
            window.clarity("event", eventName);
        }
        console.log('Clarity', eventName);
    }

    setStore(store){
        this.store = store;
    }

    getVariantStr(){
        var str = '';
        this.store.sortedStepsFlat.forEach((step) => {
            let selectedOptionName = step.selectedOption?.name ?? '';
            if (selectedOptionName) {
                str += `${step.name}: ${selectedOptionName}, `;
            }
        });
        return str;
    }

    getProductId(){
        return this.store.product.id;
    }
    getProductName(){
        return this.store.product.name;
    }

    getPrice(){
        return String(this.store.cart.totalPrice);
    }

    getSelectedFabricStr() {
        return String(this.store.selectedCategory?.name).toLowerCase() + " - " + String(this.store.selectedFabric?.name).toLowerCase();
    }

}

const Clarity = new ClarityClass();

export {
    Clarity,
    ClarityClass
}
